var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c('lottie-animation',{staticClass:"ico",attrs:{"width":200,"height":200,"path":"lottie/notification.json"}}),_c('div',{staticClass:"txt"},[_vm._v("Nouvelle Commande")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }